import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './layout.css';
import App from './App';
// La rueda del ratón no cambia los campos numéricos (entrega 326).
import { instalarSinRueda } from './utils/sinRuedaEnNumeros';

instalarSinRueda();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
